export default __webpack_public_path__ + "static/lokalizacja-bg-7353d4e210f1ec5d80307d8b3cda7d70.png";